<template>
  <b-row class="g-2">
    
    <b-col cols="6" md="3">
      <b-button
        block
        variant="primary"
        :disabled="loading === 'arquivos'"
        @click="send('arquivos')"
      >
        {{ loading === 'arquivos' ? 'Enviando...' : 'Arquivos' }}
      </b-button>
    </b-col>

    <b-col cols="6" md="3">
      <b-button
        block
        variant="primary"
        :disabled="loading === 'polishop'"
        @click="send('polishop')"
      >
        {{ loading === 'polishop' ? 'Enviando...' : 'Polishop' }}
      </b-button>
    </b-col>

    <b-col cols="6" md="3">
      <b-button
        block
        variant="primary"
        :disabled="loading === 'equals'"
        @click="send('equals')"
      >
        {{ loading === 'equals' ? 'Enviando...' : 'Equals' }}
      </b-button>
    </b-col>

    <b-col cols="6" md="3">
      <b-button
        block
        variant="primary"
        :disabled="loading === 'boaVista'"
        @click="send('boaVista')"
      >
        {{ loading === 'boaVista' ? 'Enviando...' : 'Boa Vista' }}
      </b-button>
    </b-col>

  </b-row>
</template>

<script>
import { BButton, BRow, BCol } from 'bootstrap-vue'

export default {
  name: "UploadButtons",

  props: {
    loading: String
  },

  components: {
    BButton,
    BRow,
    BCol
  },

  methods: {
    getLabel(type) {
      const labels = {
        arquivos: 'Arquivos',
        polishop: 'Polishop',
        equals: 'Equals',
        boaVista: 'Boa Vista',
      }

      return labels[type] || type
    },

    send(type) {
      this.$bvModal.msgBoxConfirm(
        `Tem certeza que deseja enviar ${this.getLabel(type)}?`,
        {
          title: 'Confirmação',
          okTitle: 'Sim',
          cancelTitle: 'Cancelar',
          centered: true,
          okVariant: 'primary',
        }
      ).then((confirmed) => {
        if (confirmed) {
          this.$emit('upload', type)
        }
      })
    },
  }
}
</script>